const Footer = () => {
  return (
    <footer className="absolute bottom-2 text-xs">
      📍 Made with love, Singapore{" "}
      <a
        className="font-bold text-yellow-600"
        href="https://github.com/gbrllim/paired-up"
      >
        Github
      </a>
    </footer>
  );
};
export default Footer;
